<template>
  <div class="dlg">
    <header class="dlg__head">
      <div class="dlg__eyebrow">
        <span class="dlg__dot"></span>
        WAIZMANNVERGLEICH / BEGRENZUNGEN
      </div>
      <h2 class="dlg__title">
        Anfängliche Leistungsbegrenzungen im Detail
      </h2>
      <p class="dlg__sub" v-if="tarif.un_name || tarif.tarif_title">
        {{ tarif.un_name }}
        <span v-if="tarif.tarif_title"> · {{ tarif.tarif_title }}</span>
      </p>
    </header>

    <div v-if="tarif.show_begrenzung_vorteil" class="dlg__note dlg__note--ok">
      <v-icon icon="mdi-lightbulb-on-outline" size="16" />
      <span>
        <strong>Experten-Tipp:</strong> Jetzt schneller
        <strong>{{ tarif.tarif_int_begrenzung_1 }}&nbsp;€</strong>
        höhere Erstattung sichern!
        <br />
        Bei Versicherungsbeginn noch in diesem Kalenderjahr sind Sie am
        1.&nbsp;Januar bereits im 2.&nbsp;Versicherungsjahr und können bereits
        nächstes Jahr <strong>{{ tarif.tarif_int_begrenzung_2 }}</strong>
        (statt {{ tarif.tarif_int_begrenzung_1 }}&nbsp;€) in Anspruch
        nehmen – ein Plus von
        <strong class="text-pos">
          {{ tarif.tarif_int_begrenzung_1 }}&nbsp;€ Erstattung
        </strong>.
      </span>
    </div>

    <div class="dlg__prose" v-html="nl2br(tarif.tarif_beschreibung_beg)"></div>
  </div>
</template>

<script setup>
  import { defineProps } from "vue";
  import { useNl2Br } from "@/composable/useNl2Br";
  const { nl2br } = useNl2Br();

  defineProps({
    tarif: { type: Object, default: () => ({}) },
    berechnung: { type: Object, default: () => ({}) },
  });
</script>

<style scoped>
  .text-pos {
    color: #2e7d32;
  }
</style>
